import { createBrowserHistory, createHashHistory } from 'history';
import React, { FC } from 'react';
import { Router as ReactRouter } from 'react-router-dom';
import { globalConfig } from '@src/config';

const hashHistory =
  globalConfig.history === 'browserHistory' ? createBrowserHistory({ window }) : createHashHistory({ window });

const globalHistory = hashHistory;

interface CustomRouterProps {
  basename?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  history?: any;
  children?: React.ReactNode;
}

const Router: FC<CustomRouterProps> = ({ basename, children, history = globalHistory }) => {
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  });

  React.useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <ReactRouter
      basename={basename?.replace(/^\./, '')}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </ReactRouter>
  );
};

export const RouterConfig = {
  history: globalHistory,
  Router,
};
